import { Box } from "@mui/material";
import "./col.css";

export const ColItem = (name) => {
  var foundName = name.foundName;

  if (foundName == null) {
    foundName = "blank";
  }

  var hoverCallBack = function () {
    name.hoverCallBack({ name: name.displayName });
  };

  var hoverEndCallBack = function () {
    name.hoverEndCallBack();
  };

  return (
    <Box
      className="gridItemHolder"
      onMouseEnter={hoverCallBack}
      onMouseLeave={hoverEndCallBack}
    >
      <Box className="anItemBoxClaimed">
        <img src={"./items/" + foundName + ".png"} />
      </Box>
      <Box className="anItemBox">
        <img
          className="colItemImage"
          src={"./collectionlog/" + name.name + ".png"}
        />
      </Box>
    </Box>
  );
};
